<template>
	<b-form
		ref="form"
		@submit.prevent="saveContact"
	>
		<b-row class="mt-3">

							<b-col cols="6">

								<b-form-group
									label="Name:"
									for="name"
								>

									<b-input
										id="name"
										v-model="contact.Name"
										type="text"
										required
									/>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									label="Position:"
									for="position"
								>
									<b-input
										id="position"
										v-model="contact.Position"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Email:"
									for="email"
								>
									<b-input
										id="email"
										v-model="contact.EmailAddress"
										type="email"
									/>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									label="Telephone:"
									for="telephone"
								>
									<b-input
										id="telephone"
										v-model="contact.Telephone"
										type="tel"
									/>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									label="Mobile:"
									for="mobile"
								>
									<b-input
										id="mobile"
										v-model="contact.Mobile"
										type="tel"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Address 1:"
									for="address1"
								>
									<b-input
										id="address1"
										v-model="contact.Address.Address1"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Address 2:"
									for="address2"
								>
									<b-input
										id="address2"
										v-model="contact.Address.Address2"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Address 3:"
									for="address3"
								>
									<b-input
										id="address3"
										v-model="contact.Address.Address3"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group
									label="Town:"
									for="town"
								>
									<b-input
										id="town"
										v-model="contact.Address.Town"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group
									label="County:"
									for="county"
								>
									<b-input
										id="county"
										v-model="contact.Address.County"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group
									label="Postcode:"
									for="postcode"
								>
									<b-input
										id="postcode"
										v-model="contact.Address.Postcode"
										type="text"
									/>
								</b-form-group>
							</b-col>
						</b-row>

			<b-button
				type="submit"
				variant="info"
			>Save Contact</b-button>  
			<b-link class="ml-3" :href="`/contacts/${contact.Id}/update`">Go to contact</b-link>

	</b-form>
</template>

<script>
import ContactService from "@/api-services/contact.service";

export default {
	name: "EditContact",

	// things we have inherited from our parent
	props: ["editing"],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			contact: {
				Name: "",
				Postition: "",
				Telephone: "",
				Mobile: "",
				Email: "",
				Address: {}
			},
           
		};
	},

	created() {
		ContactService.get(this.editing.id).then(response => {
			this.contact = response.data;

			if (this.contact.Address == null) {
				this.contact.Address = {};
			}
		});
	},

	// things we do to data
	methods: {
		saveContact() {
			ContactService.update(this.editing.id, this.contact)
				.then(() => {
					this.$emit("updateContact", this.contact);
				})
				.catch(error => {
					console.log(error.response.data);
				});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/edit-contact.vue